import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=0dc14c35&scoped=true&"
import script from "./Add.vue?vue&type=script&lang=js&"
export * from "./Add.vue?vue&type=script&lang=js&"
import style0 from "./Add.vue?vue&type=style&index=0&id=0dc14c35&lang=scss&"
import style1 from "./Add.vue?vue&type=style&index=1&id=0dc14c35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc14c35",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dc14c35')) {
      api.createRecord('0dc14c35', component.options)
    } else {
      api.reload('0dc14c35', component.options)
    }
    module.hot.accept("./Add.vue?vue&type=template&id=0dc14c35&scoped=true&", function () {
      api.rerender('0dc14c35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseorder/Add.vue"
export default component.exports